import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { List, Icon } from 'antd';
import { toTimezone } from 'utils/dateTimeUtils';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import Enums from 'utils/EnumsManager';
import styles from '../index.less';

const { Item } = List;
const cx = classNames.bind(styles);
const {
  DateOnly,
  DateTime,
  Lookup,
} = Enums.FieldTypes;
const dateFormat = {
  month: 'MMM YYYY',
  week: 'WW YYYY',
};

const dateRange = [
  'day',
  'week',
  'month',
  'quarter',
  'year',
];

class Table extends React.Component {
  renderRowItem = (item) => {
    const { related_meta } = this.props.slotDetail;
    const rowItem = _.isObject(item) && _.isObject(related_meta) && Object.keys(related_meta).map((key, index) => {
      let text = item[key];
      // if (related_meta[key].crm_data_type === DateOnly || related_meta[key].crm_data_type === DateTime) {
      //   switch (true) {
      //     case _.endsWith(key, 'day'):
      //       text = item[key];
      //       break;

      //     case _.endsWith(key, 'week'):
      //       text = moment(item[key], 'YYYY-WW').format(dateFormat.week);
      //       break;

      //     case _.endsWith(key, 'month'):
      //       text = moment(item[key], 'YYYY-MM').format(dateFormat.month);
      //       break;

      //     default:
      //       text = item[key];
      //   }
      // }
      // TODO add lookup type to the row
      if (_.isObject(related_meta) && _.isObject(related_meta[key]) && related_meta[key].crm_data_type === Lookup) {
        text = item[key].name;
      }
      return (<span key={index}>{text}</span>);
    });
    return rowItem;
  }

  renderHeader = (slotDetail) => {
    const header = _.isObject(slotDetail.related_meta) && Object.keys(slotDetail.related_meta).map((key, index) => {
      let text = '';

      const icon =
        // eslint-disable-next-line no-nested-ternary
        slotDetail.setup_properties &&
        slotDetail.setup_properties.order_by &&
        !_.isEmpty(slotDetail.setup_properties.order_by.direction) ?
          (slotDetail.setup_properties.order_by.direction === 'desc' ? <Icon type="caret-down" /> : <Icon type="caret-up" />) : '';

      switch (true) {
        case _.endsWith(key, 'sum'):
          text = (
            <FormattedMessage
              id="page.dashboard.sum"
              defaultMessage="Sum"
              values={{ label: slotDetail.related_meta[key].field_label }}
            />
          );
          break;

        case _.endsWith(key, 'avg'):
          text = (
            <FormattedMessage
              id="page.dashboard.avg"
              defaultMessage="Average"
              values={{ label: slotDetail.related_meta[key].field_label }}
            />
          );
          break;

        case key === 'count':
          text = (
            <FormattedMessage id="page.dashboard.count" />
          );
          break;

        case slotDetail.related_meta[key].crm_data_type === DateOnly:
        case slotDetail.related_meta[key].crm_data_type === DateTime:
          dateRange.forEach(d => {
            if (_.endsWith(key, d)) {
              text = `${slotDetail.related_meta[key].field_label} (${d})`;
            }
          });
          break;

        default:
          text = slotDetail.related_meta[key].field_label;
      }
      return (
        <span key={key}>
          {text} { slotDetail.setup_properties && slotDetail.setup_properties.order_by && key === slotDetail.setup_properties.order_by.field_name ? icon : ''}
        </span>
      );
    });
    return header;
  }

  render() {
    const { slotDetail } = this.props;
    return (
      <List
        size="small"
        className="report-card-list"
        header={this.renderHeader(slotDetail)}
        dataSource={
          slotDetail.bind_data_source &&
          _.isArray(slotDetail.bind_data_source.last_success_refresh_data_for_slot) ?
          slotDetail.bind_data_source.last_success_refresh_data_for_slot : []
        }
        renderItem={item => (<Item>{this.renderRowItem(item)}</Item>)}
      />
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/rightSection/card/table.jsx